/**
 * @name paper-bag
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNS4zNjQgMy44NDhDNCA2IDMgOS42NTIgMyAxMi42NTJWMTlhMiAyIDAgMDAyIDJoMTRhMiAyIDAgMDAyLTJ2LTVjMC0yLjMzNC0xLjgxNi00LjY2OC0yLjYyMi03LjAwMiIgLz4KICA8cGF0aCBkPSJNNyAzaDExLjM3OWEyIDIgMCAwMTEuNzg5IDEuMTA2bC43MjMgMS40NDdBMSAxIDAgMDExOS45OTcgN2gtOC41MjVhMiAyIDAgMDEtMS43ODktMS4xMDZMOC43OSA0LjEwNWEyIDIgMCAxMC0zLjU3OSAxLjc4OWwyLjI2MSA0LjUyMkE1IDUgMCAwMTggMTIuNjUyVjIxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/paper-bag
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const PaperBag: string = `
<svg
  class="lucide lucide-paper-bag"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M5.364 3.848C4 6 3 9.652 3 12.652V19a2 2 0 002 2h14a2 2 0 002-2v-5c0-2.334-1.816-4.668-2.622-7.002" />
  <path d="M7 3h11.379a2 2 0 011.789 1.106l.723 1.447A1 1 0 0119.997 7h-8.525a2 2 0 01-1.789-1.106L8.79 4.105a2 2 0 10-3.579 1.789l2.261 4.522A5 5 0 018 12.652V21" />
</svg>
`;

export default PaperBag;
